module.exports = __webpack_public_path__ + "static/img/homenew2.04d8f582.png";